/**
 * @file app/constants/widgets.js
 */

// NOTES:
// - For business widget types the url gets its base prepended from BARCHART_BASE_URL
// - the types region, schedule do not require additional configurations

export const BARCHART_BASE_URL = "https://cbc2.websol.barchart.com";

// Configuration for Generic Widgets, for the images please upload to
// Polopoly.
export const SIDEBAR_WIDGETS = {
    goPublicForm: {
        height: "490px",
        name: "goPublic",
        src: "https://www.cbc.ca/news2/interactives/forms/go-public/",
        type: "form",
    },
    region: {
        type: "region",
    },
    radioCanadaInternational: {
        callToActionText: "visit Radio Canada International",
        descriptionId: "card-rci-description",
        description:
            "RCI is CBC/Radio-Canada's multilingual service, forging bonds between Canadians and citizens of the world",
        external: true,
        imageURL:
            "https://i.cbc.ca/1.6102254.!/fileImage/httpImage/rci-logo.jpg",
        title: "Radio-Canada International",
        type: "imageLink",
        url: "https://ici.radio-canada.ca/rci/en",
    },
    schedule: {
        type: "schedule",
    },
    scheduleBasketballCEBL: {
        type: "schedule",
        filter: "CEBL",
        fullScheduleUrl: "https://www.cbc.ca/sports/basketball/cebl/broadcast/",
    },
    scheduleCurling: {
        type: "schedule",
        filter: "curling",
        fullScheduleUrl:
            "https://www.cbc.ca/sports/olympics/winter/curling/broadcast/",
    },
    scheduleFigureskating: {
        type: "schedule",
        filter: "figure skating",
        fullScheduleUrl:
            "https://www.cbc.ca/sports/olympics/winter/figureskating/broadcast",
    },
    scheduleRugby: {
        type: "schedule",
        filter: "rugby",
        fullScheduleUrl:
            "https://www.cbc.ca/sports/streaming-schedule?sport=Rugby",
    },
    scheduleCPL: {
        type: "schedule",
        filter: "CPL",
        fullScheduleUrl: "https://www.cbc.ca/sports/soccer/cpl/broadcast/",
    },
    scheduleNHL: {
        type: "schedule",
        filter: "hockey night in canada",
        fullScheduleUrl:
            "https://www.cbc.ca/sports/streaming-schedule?sport=Hockey%20Night%20In%20Canada",
    },
    scheduleStampede: {
        type: "schedule",
        filter: "calgary stampede",
        fullScheduleUrl:
            "https://www.cbc.ca/sports/calgarystampede/2019-calgary-stampede-schedule-1.5189169",
    },
    scheduleSkiing: {
        type: "schedule",
        filter: "skiing",
        fullScheduleUrl:
            "https://www.cbc.ca/sports/olympics/winter/skiing/broadcast",
    },
    scheduleParalympics: {
        type: "schedule",
        filter: "paralympics",
        fullScheduleUrl:
            "https://www.cbc.ca/sports/paralympics/streaming-schedule",
    },
    scheduleTrackandfield: {
        type: "schedule",
        filter: "athletics",
        fullScheduleUrl:
            "https://www.cbc.ca/sports/olympics/summer/trackandfield/broadcast",
    },
    secureDrop: {
        callToActionText: "learn more",
        descriptionId: "card-secure-drop-description",
        description:
            "Contact CBC and our top investigative journalists securely and anonymously with SecureDrop.",
        external: true,
        imageURL:
            "https://i.cbc.ca/1.4829617.1537367557!/fileImage/httpImage/image.png_gen/derivatives/original_1180/image.png",
        title: "SecureDrop",
        type: "secureDrop",
        url: "https://www.cbc.ca/securedrop/",
        widgetClassName: "secureDropWidget",
    },
};

// Configures which widgets should display on each page
// Client.sidebarWidgets contains the configuration for region,
// generic, business and schedule widgets
// Client.shows handle anything starting with "series.X", where X is a
// value that comes from Client.showPages
// Trending requires no configuration
// FollowUs widgets are driven by FollowUs/constants > FOLLOWUS_LIST

export const PAGE_WIDGETS = {
    "2017/becoming-canadian": ["trending"],
    "2017/canadathestoryofus": ["trending"],
    "2017/canadathestoryofus/csou-episodes": ["trending"],
    "2017/truenorthcalling": ["trending"],
    "2017/we-are-the-best": ["trending"],
    "2017/wearecanada": ["trending"],
    "arts/exhibitionists": ["trending"],
    "arts/thefilmmakers": ["trending"],
    "arts/interruptthisprogram": ["trending"],
    "arts/crashgallery": ["trending"],
    "arts/disruptingdesign": ["trending"],
    "arts/thecollective": ["trending"],
    "arts/eddyrogo": ["trending"],
    "books/canadareads": ["trending"],
    "books/tdkids": [],
    homepage: [],
    "life/backintimefordinner": ["trending"],
    "life/food": ["trending"],
    "life/getawayguide": ["trending"],
    "life/greatcanadianbakingshow": ["trending"],
    "life/holiday": ["sponsor", "trending"],
    "life/holiday/cbcgives": ["trending"],
    "life/thegoods": ["trending"],
    "life/wellness": ["trending"],
    "news/canada": ["region"],
    "news/gopublic": ["goPublicForm"],
    "news/indigenous": ["creeWidget", "espacesAutochtones", "unreserved"],
    "news/investigates": ["secureDrop"],
    "news/politics": ["powerAndPolitics", "theHouse", "rosemaryBarton"],
    "news/politics/powerandpolitics": [
        "powerPanel",
        "premiersLeague",
        "powerLunch",
    ],
    "news/technology": ["quirksAndQuarks"],
    "news/thenational": ["nationalShow", "nationalPodcast"],
    "sports/basketball/cebl": ["scheduleBasketballCEBL"],
    "sports/calgarystampede": ["scheduleStampede"],
    "sports/olympics": ["schedule"],
    "sports/paralympics": ["scheduleParalympics"],
    "sports/rugby": ["scheduleRugby"],
    "sports/soccer/cpl": ["scheduleCPL"],
};
